import { useMemo } from "react";
import { countryCodeToCountryName } from "@/utils/countries.util";
import { LocationAutocompleteEntryDto } from "@advanced-sales-technologies/backend-client/models/LocationAutocompleteEntryDto";
import { useTranslation } from "react-i18next";

type LocationSelectItemProp = {
  location: LocationAutocompleteEntryDto;
};

const LocationSelectItem = ({ location }: LocationSelectItemProp) => {
  const { t } = useTranslation();
  const country = countryCodeToCountryName(location.country_code);
  const count = new Intl.NumberFormat().format(location.count || 0);

  const target = useMemo(() => {
    switch (location.target) {
      case "COUNTRY_CODE":
        return t("search.filter.location.targets.COUNTRY_CODE");
      case "REGION":
        return t("search.filter.location.targets.REGION");
      default:
        return t("search.filter.location.targetInCountry", {
          target: t(`search.filter.location.targets.` + location.target),
          country: country,
        });
    }
  }, [location.target, country, t]);

  return (
    <div className={"flex max-w-full flex-col"}>
      <div className={"flex shrink items-center gap-1 text-sm"}>
        <div className={"truncate text-secondary"}> {location.target === "COUNTRY_CODE" ? country : location.name}</div>
        <span className={"shrink-0 text-quaternary"}>({count})</span>
      </div>
      {target && <div className={"truncate text-xs text-quaternary"}>{target}</div>}
    </div>
  );
};

export default LocationSelectItem;
